import { Component, Input, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CnafAtTagService, ClickInfo } from '@cnaf/ng-cnaf-commons';
import { ConstanteUri } from 'src/app/constants/constante-uri';
import { ConstantePage } from 'src/app/constants/constante-page';

@Component({
  selector: 'app-bouton-quitter',
  templateUrl: './bouton-quitter.component.html'
})
export class BoutonQuitterComponent {

  modalRef!: BsModalRef;

  @Input() pageName: string;

  /**
   * Constructeur du composant 
   * @param modalService 
   * @param cnafAtTagService 
   */
  constructor(
    private modalService: BsModalService, 
    private cnafAtTagService: CnafAtTagService) { 
  }

  /**
   * Ouverture de la modale
   * @param template 
   */
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  /**
   * Fermeture de la modale
   */
  closeModal() {
    if(this.modalRef!=null) {
      this.modalRef.hide();
    }
  }

  /**
   * Traitement pour quitter l'application : 
   * Envoi tag WA
   * Redirection vers mon compte selon le mode MOBILE / WEB
   */
  quitterAction() {
    if(this.modalRef!=null) {
      
      const clickInfo: ClickInfo = {
        name: 'abandon',
        type: 'Action',
        level2: ConstantePage.STATS_LEVEL2,
        chapter1: ConstantePage.STATS_CHAPTER1,
        chapter2: ConstantePage.STATS_CHAPTER2,
        chapter3: this.pageName
      };
      
      if(this.pageName!=undefined) {
        this.cnafAtTagService.click( clickInfo );
      }

      this.modalRef.hide();
     
      // Pas de atinternet dans ce cas comme dans l'ancien simulateur
      window.location.assign(ConstanteUri.URL_REDIRECT_EXIT);

    }
  }

}
